import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Loader from "../../components/Common/Loader";

//Action
import { leadsCreate, leadsList } from "../../store/leads/actions";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PreContactAdd = (props) => {
  const dispatch = useDispatch();
  const [checked, setchecked] = useState(false);
  const history = useHistory();
  const es_empresa = checked;
  console.log(es_empresa);

  const changeLista = (e) => {
    setchecked(e.target.checked);
  };

  useEffect(() => {
    dispatch(leadsList());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    razon_social: "",
    email: "",
    address: "",

  });

  const { first_name, last_name, razon_social, email, address } =
    formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };



  const [phone, setphone] = useState('')

  const handleChange = (value) =>{
    setphone(value)
  }
  
console.log(phone)

  const onSubmit = (e) => {
    e.preventDefault();
    props.leadsCreate({
      first_name,
      last_name,
      razon_social,
      email,
      address,
      phone,
    });
  };
  console.log(props.location.state);

  const redirect = () => {
    history.push("/leads");
  };

  const goback = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>tccontrol | Pre-Contacto</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb
            title={"tccontrol"}
            breadcrumbItem={"Agregar Contactos"}
          />
          {props.loading ? (
            <Loader />
          ) : (
            <Card className="col-lg-8 mx-auto  mt-3">
              {props.leadsCreated.id ? (
                <SweetAlert
                  title="Hecho!"
                  success
                  timeout={1000}
                  showConfirm={false}
                  onConfirm={() => {
                    props.location.state ? goback() : redirect();
                  }}
                >
                  Se ha agregado el PreContacto con el numero{" "}
                  {props.leadsCreated.id}
                </SweetAlert>
              ) : null}
              <CardBody>
                <h4 className="card-title">Crear Nuevo Pre-Contacto </h4>

                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input mt-2 "
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    onChange={changeLista}
                    checked={checked}
                  />
                  <Label
                    className="form-check-label mt-2 "
                    for="flexSwitchCheckChecked"
                  >
                    <strong>Empresa</strong>{" "}
                  </Label>
                </div>
                <Form
                  className="form-control needs-validation"
                  onSubmit={onSubmit}
                >
                  {!checked ? (
                    <>
                      {" "}
                      {/* Datos Persona Natural*/}
                      <Row>
                        <Col lg={6} className="mb-3">
                          <Label for="first_name" className="form-label">
                            Nombre
                          </Label>
                          <Input
                            id="first_name"
                            name="first_name"
                            type="text"
                            onChange={onChange}
                            value={first_name}
                            required={true}
                          />
                        </Col>
                        <Col lg={6} className="mb-3">
                          <Label for="last_name" className="form-label">
                            Apellido
                          </Label>
                          <Input
                            id="last_name"
                            name="last_name"
                            type="text"
                            onChange={onChange}
                            value={last_name}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6} className="mb-3">
                          <Label for="email" className="form-label">
                            email
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            onChange={onChange}
                            value={email}
                          />
                        </Col>
                        <Col lg={6} className="mb-3">
                          <Label for="address" className="form-label">
                            Direccion
                          </Label>
                          <Input
                            id="address"
                            name="address"
                            type="text"
                            onChange={onChange}
                            value={address}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6} className="mb-3">
                          <Label for="phone" className="form-label">
                            telefono
                          </Label>
                          <PhoneInput
                            country={'us'}
                            id="phone"
                            name="phone"
                            type="text"
                            onChange={handleChange}
                            value={phone}
                          />
                        </Col>
                      </Row>
                      <Row className="col-lg-12 justify-content-center">
                        <Col md={1} className="mx-1">
                          <Button color="primary" type="submit">
                            Enviar
                          </Button>
                        </Col>
                        <Col md={1} className="mx-1">
                          <button
                            className="btn btn-secondary"
                            onClick={goback}
                            type="button"
                          >
                            Volver
                          </button>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      {/* Datos de Empresa */}
                      <Row>
                        <Col lg={6} className="mb-3">
                          <Label for="razon_social" className="form-label">
                            Razon Social
                          </Label>
                          <Input
                            id="razon_social"
                            name="razon_social"
                            type="text"
                            onChange={onChange}
                            value={razon_social}
                            required={true}
                          />
                        </Col>
                        <Col lg={6} className="mb-3">
                          <Label for="email" className="form-label">
                            Email
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            onChange={onChange}
                            value={email}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={6} className="mb-3">
                          <Label for="address" className="form-label">
                            Direccion
                          </Label>
                          <Input
                            id="address"
                            name="address"
                            type="text"
                            onChange={onChange}
                            value={address}
                          />
                        </Col>
                        <Col lg={6} className="mb-3">
                          <Label for="phone" className="form-label">
                            Telefono
                          </Label>
                          <Input
                            id="phone"
                            name="phone"
                            type="text"
                            onChange={onChange}
                            value={phone}
                          />
                        </Col>
                      </Row>

                      <Row className="col-lg-12 justify-content-center">
                        <Col md={1} className="mx-1">
                          <Button color="primary" type="submit">
                            Enviar
                          </Button>
                        </Col>
                        <Col md={1} className="mx-1">
                          <button
                            className="btn btn-secondary"
                            onClick={goback}
                            type="button"
                          >
                            Volver
                          </button>
                        </Col>
                      </Row>
                    </>
                  )}
                </Form>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  const { error, loading, leadsCreated } = state.Leads;
  return { error, loading, leadsCreated };
};

PreContactAdd.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  leadsCreated: PropTypes.object,
};

export default withRouter(
  connect(mapStateToProps, { leadsCreate })(PreContactAdd)
);
